package com.essntl.uikit.components.file

import androidx.compose.runtime.Composable
import com.mohamedrejeb.calf.io.KmpFile

@Composable
actual fun rememberFileSaverLauncher(
    onResult: (KmpFile?) -> Unit
): FileSaverLauncher =
    FileSaverLauncher()

actual class FileSaverLauncher

actual fun FileSaverLauncher.launch(bytes: ByteArray?, baseName: String, extension: String, initialDirectory: String?) {
    println("FileSaverLauncher is not supported on this platform")
}